import { Component, Inject, OnDestroy } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-view-details-loader',
  templateUrl: './view-details-loader.component.html',
  styleUrls: ['./view-details-loader.component.css'],
  standalone: true
})
export class ViewDetailsLoaderComponent implements OnDestroy {
  private unsubscribe$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ViewDetailsLoaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.observeDataChanges();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  observeDataChanges() {
    this.data?.modalClose$.pipe(takeUntil(this.unsubscribe$)).subscribe((modalClose: boolean) => {
      if (modalClose) {
        this.dialogRef.close();
      }
    });
  }
}
